import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { obtenerRutaPorDefecto } from "../../../utils/rutaHelpers";
import type { IUsuarioCredencial } from "../../../modelos/Autenticacion/entidades/IUsuarioCredencial";
import { useAutenticacion } from "../../../globales/contextos/authContext";
import { useNotificaciones } from "../../../globales/contextos/notificationContext";
import { EnumTipoNotificacion } from "../../../globales/interfaces";
import type { IUsuarioAutenticado } from "../../../modelos/Autenticacion/entidades/IUsuarioAutenticado";
import FormularioAutenticacionVista from "../vista/formularioAutenticacionVista";
import ModeloAutenticacion from "../../../modelos/Autenticacion";
import { useCargando } from "../../../globales/contextos/cargandoContext";

const FormularioAutenticacionCV = () => {
    const atenticacionModelo = new ModeloAutenticacion();
    const [inputsUsuario, setInputsUsuario] = useState<IUsuarioCredencial>({
        Usuario: '',
        Contrasena: ''
    });
    const [cargando, setCargando] = useState(false);
    const { mostrarNotificacion } = useNotificaciones();
    const { iniciarSesion } = useAutenticacion();
    const navigate = useNavigate();
    const { manejarCargando } = useCargando()


    const alCambiarValor = (
        nombreFiltro: keyof IUsuarioCredencial,
        nuevoValor: IUsuarioCredencial[keyof IUsuarioCredencial]
    ) => {
        setInputsUsuario(prev => ({
            ...prev,
            [nombreFiltro]: nuevoValor
        }));
    };

    const validarCampos = () => {
        if (!inputsUsuario.Usuario || !inputsUsuario.Contrasena) {
            mostrarNotificacion(
                EnumTipoNotificacion.Warning,
                '¡Campos requeridos!',
                'Por favor completa todos los campos antes de continuar.',
                3000
            );
            return false;
        }
        return true;
    };

    const inicioSesion = async () => {
        if (!validarCampos()) return;
        try {
            setCargando(true);
            const respuesta = await atenticacionModelo.iniciarSesion(inputsUsuario);
            if (respuesta) {
                if (
                    respuesta.NotificationType === EnumTipoNotificacion.Success &&
                    respuesta.Data
                ) {
                    const usuarioAutenticado: IUsuarioAutenticado = respuesta.Data;
                    if (usuarioAutenticado.Permisos.length > 0) {
                        // usuarioAutenticado.Expiration = '2025-09-20T12:37:03.0540288Z'
                        iniciarSesion(usuarioAutenticado);
                        mostrarNotificacion(
                            EnumTipoNotificacion.Success,
                            '¡Bienvenido!',
                            `Hola ${usuarioAutenticado.NombreCompleto}, has iniciado sesión correctamente.`,
                            4000
                        );

                        manejarCargando(true, "Redirigiendo...");
                        const rutaDestino = obtenerRutaPorDefecto();
                        navigate(rutaDestino, { replace: true });

                        // Opcional: dar un pequeño delay antes de quitar el loading global
                        setTimeout(() => manejarCargando(false), 300);
                        return;
                    }
                    else {
                         mostrarNotificacion(
                            EnumTipoNotificacion.Warning,
                            'No puedes ingresar',
                            `Hola ${usuarioAutenticado.NombreCompleto}, no tienes permisos asignados para acceder al sistema. Por favor contacta al administrador.`,
                            4000
                        );
                    }
                }

                if (respuesta.Messages.length > 0) {
                    respuesta.Messages.forEach(mensaje =>
                        mostrarNotificacion(
                            respuesta.NotificationType,
                            '',
                            mensaje,
                            4000
                        )
                    );
                }
            }
        } catch {
            mostrarNotificacion(
                EnumTipoNotificacion.Error,
                'Error al iniciar sesión',
                'No fue posible iniciar sesión. Por favor verifica tu conexión e intenta nuevamente.',
                5000
            );
        } finally {
            setCargando(false);
        }
    };


    return (
        <>
            <FormularioAutenticacionVista
                iniciarSesion={inicioSesion}
                inputsUsuario={inputsUsuario}
                alCambiarValor={alCambiarValor}
                cargando={cargando}
            />
        </>
    );

};

export default FormularioAutenticacionCV;
